import React, { useEffect, useRef } from 'react';
import useIsMount from '@/util/hook/useIsMount.ts';
import UnifiedMap from '@/component/map/unified/UnifiedMap';
import UnifiedMarker from '@/component/map/unified/UnifiedMarker';

import { useMapType } from '@/component/map/MapContext';

interface IProps {
    className?: string;
    latitude?: number;
    longitude?: number;
}

const DefaultMap: React.FunctionComponent<IProps> = ({ className, latitude, longitude }) => {
    const { isMount } = useIsMount();
    const mapRef = useRef<any>(null);
    const { mapType } = useMapType();

    const center = {
        lat: latitude ?? 37.5759,
        lng: longitude ?? 126.9768
    };

    useEffect(() => {
        if (mapRef.current) {
            if (mapType === 'google') {
                mapRef.current.panTo(center);
            }
        }
    }, [latitude, longitude]);

    const mapOptions = {
        zoom: 15,
        mapId: mapType === 'google' ? '8d4d2c95ae9b2bdf' : undefined,
        zoomControl: false,
        streetViewControl: false,
        fullscreenControl: false
    };

    return (
        <div className={`${className} relative`} onClick={e => e.stopPropagation()}>
            {isMount && latitude && longitude && (
                <>
                    <UnifiedMap
                        mapContainerStyle={{ width: '100%', height: '100%' }}
                        center={center}
                        zoom={mapOptions.zoom}
                        options={mapOptions}
                        onLoad={(map) => {
                            mapRef.current = map;
                        }}
                    >
                        <UnifiedMarker
                            position={center}
                        />
                    </UnifiedMap>
</>
            )}
        </div>
    );
};

export default DefaultMap;
